import { useState, useEffect, useContext, useRef } from 'react'
import ContextStates from '../../context/ContextStates';
import { FaPen, FaTrash, FaPlus, FaBarcode, FaShoppingCart, FaDollarSign, FaBox } from 'react-icons/fa'
import axios from 'axios';
import { Url } from '../Url';
import FooterVenta from '../footerVenta';
import SearchAutoComplete from '../searchAutoComplete';


const FormVentas = () => {
    const [cantidad, setCantidad] = useState('')
    const [producto, setProducto] = useState({})
    const [combo, setCombo] = useState({})
    const [descripcion, setDescripcion] = useState('')
    const [precioUnitario, setPrecioUnitario] = useState('')
    const { productos, setProductos, combos, setCombos, codigo, setCodigo, venta, setVenta, setProductoSelected, setViewOpen,
        modify, setFormView, tipoPrecio, searchTerm, setSearchTerm, idUsuario } = useContext(ContextStates)

    const inputRef = useRef(null);
    const cantRef = useRef(null);
    const searchRef = useRef(null)

    useEffect(() => {
        const getProductos = async () => {
            const formData = new FormData()
            formData.append("idusuario", idUsuario)
            try {
                const results = await axios({
                    url: Url + 'api/listadoproductos.php',
                    method: 'POST',
                    data: formData,
                })
                console.log("listadoprods ", results.data.results)
                setProductos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getProductos()
    }, [modify])

    useEffect(() => {
        const getCombos = async () => {
            const formData = new FormData()
            formData.append('id', 1);
            try {
                const results = await axios({
                    url: Url + 'api/listCombosVenta.php',
                    method: 'POST',
                    data: formData,
                })
                console.log(results.data.results)
                setCombos(results.data.results);
            } catch (e) {
                console.log(e)
            }
        }
        getCombos()
    }, [modify])


    useEffect(() => {
        const addProducto = async () => {
            if (typeof producto !== 'undefined') {
                if (producto.codigo) {
                    const auxVenta = JSON.stringify(venta)
                    const formData = new FormData()
                    formData.append('venta', auxVenta);
                    formData.append('producto', JSON.stringify(producto));
                    try {
                        const response = await axios({
                            url: Url + 'api/addProducto.php',
                            'Content-Type': 'application/json',
                            method: 'POST',
                            data: formData,
                            dataType: 'JSON',
                        })
                        setVenta(response.data.results);
                        setSearchTerm('')
                        setProducto({})
                        setCantidad('')
                        setPrecioUnitario('')
                    } catch (e) {
                        console.log(e)
                    }
                }
            }
        }
        addProducto()
    }, [producto])

    useEffect(() => {
        const addCombo = async () => {
            if (typeof combo !== 'undefined') {
                if (combo.codigo) {
                    const auxVenta = JSON.stringify(venta)
                    const formData = new FormData()
                    formData.append('venta', auxVenta);
                    formData.append('combo', JSON.stringify(combo));
                    try {
                        const response = await axios({
                            url: Url + 'api/addCombo.php',
                            'Content-Type': 'application/json',
                            method: 'POST',
                            data: formData,
                            dataType: 'JSON',
                        })
                        console.log(response)
                        setVenta(response.data.results);
                        setCombo({})
                        setCantidad('')
                        setPrecioUnitario('')
                    } catch (e) {
                        console.log(e)
                    }
                }
            }
        }
        addCombo()
    }, [combo])


    useEffect(() => {
        const checkDatos = () => {
            productos.forEach(element => {
                if (element.codigo === codigo) {
                    setSearchTerm(element.descripcion)
                    if (tipoPrecio === 1) {
                        if (element.tipopromo === '1' || element.tipopromo === '2') {
                            setPrecioUnitario(element.preciopromocion)
                        }
                        else {
                            setPrecioUnitario(element.precio)
                        }
                    }
                    else {
                        setPrecioUnitario(element.preciopormayor)
                    }

                }
            });
            if (cantidad === '') {
                if (codigo === '') {
                    searchRef.current.focus()
                }
                else {
                    cantRef.current.focus()
                }
            }
        }
        checkDatos()
    }, [codigo])

    useEffect(() => {
        const handleSetPrecio = () => {
            if (codigo != '') {
                productos.forEach(element => {
                    if (element.codigo === codigo) {
                        if (element.idunidad !== '1') {
                            let aux = 0;
                            if (tipoPrecio === 1) {
                                if (element.tipopromo === '1' || element.tipopromo === '2') {
                                    aux = parseFloat(precioUnitario) / parseFloat(element.preciopromocion);
                                }
                                else {
                                    aux = parseFloat(precioUnitario) / parseFloat(element.precio);
                                }
                            }
                            else {
                                aux = parseFloat(precioUnitario) / parseFloat(element.preciopormayor);
                            }
                        }
                    }
                });
            }
        }
        handleSetPrecio()
    }, [precioUnitario])

    const preAdd = async (event) => {
        event.preventDefault();
        if (cantidad !== '') {
            const formData = new FormData()
            formData.append('codigo', codigo);
            formData.append('cantidad', cantidad);

            let aux = await productos.find(element => element.codigo === codigo);
            if (typeof aux !== 'undefined') {
                aux.cantidad = cantidad;
                aux.codigo = codigo;
                setProducto(aux)
            }
            else {
                aux = await combos.find(element => element.codigo === codigo);
                if (typeof aux !== 'undefined') {
                    console.log("cantidad disponible de combo ", aux.cantidad)
                    aux.cantidad = cantidad;
                    setCombo(aux)
                }
            }
            setCodigo('')
        }
        else {
            cantRef.current.focus()
        }
    }

    const submitCantidad = (event) => {
        event.preventDefault();
        if (cantidad !== '' && codigo !== '') {
            preAdd(event)
            searchRef.current.focus()
        }
    }

    const handleAdd = (e) => {
        preAdd(e)
        searchRef.current.focus()
    }

    const handleDelete = (item) => {
        let rData = []
        venta.forEach(element => {
            if (element.linea !== item.linea) {
                rData.push(element)
            }
        });
        setVenta(rData)
    }

    const handleSet = (item) => {
        setProductoSelected(item)
        setFormView(1)
        setViewOpen(true)
    }

    const calcTotal = (item) => {
        let precio = 0;
        if (item.cantidad >= item.cantidadminima) {
            let cantPromos = parseFloat(item.cantidad) / parseFloat(item.cantidadminima);
            let cantPagos = item.cantidad - (parseFloat(item.cantidaddescuento) * cantPromos);
            precio = cantPagos * parseFloat(item.precio);
        } else {
            precio = parseFloat(item.cantidad) * parseFloat(item.precio);
        }
        return (precio);
    }

    // Determine price type styling
    const getPriceTypeStyle = () => {
        switch (tipoPrecio) {
            case 1:
                return 'from-indigo-500 to-blue-600';
            case 2:
                return 'from-orange-500 to-amber-600';
            case 3:
                return 'from-green-500 to-emerald-600';
            default:
                return 'from-indigo-500 to-blue-600';
        }
    }

    const getPriceTypeBg = () => {
        switch (tipoPrecio) {
            case 1:
                return 'from-indigo-50 to-blue-50';
            case 2:
                return 'from-orange-50 to-amber-50';
            case 3:
                return 'from-green-50 to-emerald-50';
            default:
                return 'from-indigo-50 to-blue-50';
        }
    }

    return (
        <div className='flex flex-col min-h-screen bg-gradient-to-br from-slate-50 via-blue-50 to-indigo-50'>
            {/* Header with price type indicator */}
            <div className={`bg-gradient-to-r ${getPriceTypeStyle()} text-white py-4 px-4 shadow-lg`}>
                <div className="max-w-7xl mx-auto">
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-3">
                            <FaShoppingCart className="text-2xl" />
                            <h1 className="text-2xl font-bold">Punto de Venta</h1>
                        </div>
                        <div className="flex items-center gap-2 bg-white/20 px-4 py-2 rounded-lg backdrop-blur-sm">
                            <FaDollarSign />
                            <span className="font-semibold">
                                {tipoPrecio === 1 ? 'Precio Normal' : tipoPrecio === 2 ? 'Precio 2' : 'Precio 3'}
                            </span>
                        </div>
                    </div>
                </div>
            </div>

            {/* Input Form Card */}
            <div className="w-full px-4 py-6">
                <div className={`max-w-7xl mx-auto bg-gradient-to-r ${getPriceTypeBg()} rounded-xl shadow-lg border-2 ${tipoPrecio === 1 ? 'border-indigo-200' : tipoPrecio === 2 ? 'border-orange-200' : 'border-green-200'} p-6`}>
                    <div className="grid grid-cols-1 md:grid-cols-12 gap-4">
                        {/* Código */}
                        <div className="md:col-span-2">
                            <form onSubmit={preAdd}>
                                <label htmlFor="codigo" className="flex items-center gap-2 text-gray-700 font-bold mb-1 text-sm">
                                    Código
                                </label>
                                <input
                                    type="text"
                                    className="py-2 px-4 w-full rounded-lg border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white font-medium"
                                    id="codigo"
                                    ref={inputRef}
                                    placeholder="Código"
                                    value={codigo}
                                    onChange={(e) => setCodigo(e.target.value)}
                                    autoFocus
                                />
                            </form>
                        </div>

                        {/* Búsqueda */}
                        <div className="md:col-span-5">
                            <SearchAutoComplete
                                items={productos}
                                innerRef={searchRef}
                            />
                        </div>

                        {/* Precio Unitario */}
                        <div className="md:col-span-2">
                            <label htmlFor="punitario" className="flex items-center gap-2 text-gray-700 font-bold mb-1 text-sm">
                                Precio/u
                            </label>
                            <input
                                type="text"
                                className="py-2 px-4 w-full rounded-lg border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white font-medium text-right"
                                id="punitario"
                                value={precioUnitario}
                                onChange={(e) => setPrecioUnitario(e.target.value)}
                            />
                        </div>

                        {/* Cantidad */}
                        <div className="md:col-span-2">
                            <form onSubmit={submitCantidad}>
                                <label htmlFor="cantidad" className="block text-gray-700 font-bold mb-1 text-sm">
                                    Cantidad
                                </label>
                                <input
                                    type="number"
                                    className="py-2 px-4 w-full rounded-lg border-2 border-gray-300 focus:border-blue-500 focus:ring-2 focus:ring-blue-200 transition-all duration-200 bg-white font-medium text-center"
                                    id="cantidad"
                                    ref={cantRef}
                                    placeholder="Cant."
                                    value={cantidad}
                                    onChange={(e) => setCantidad(e.target.value)}
                                />
                            </form>
                        </div>

                        {/* Botón Agregar */}
                        <div className="md:col-span-1 flex items-end">
                            <button
                                type="button"
                                className={`w-full py-3 px-4 bg-gradient-to-r ${getPriceTypeStyle()} text-white hover:shadow-lg transform hover:scale-105 transition-all duration-200 font-bold rounded-lg flex items-center justify-center gap-2`}
                                onClick={(e) => handleAdd(e)}
                            >
                                <FaPlus />
                                <span className="hidden lg:inline">Agregar</span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* Table */}
            <div className="w-full px-4 flex-1 pb-24">
                <div className="max-w-7xl mx-auto">
                    {typeof venta !== 'undefined' && venta.length > 0 && (
                        <div className="bg-white rounded-xl shadow-lg overflow-hidden border border-gray-200">
                            <div className='overflow-x-auto'>
                                <table className='w-full'>
                                    <thead>
                                        <tr className='bg-gradient-to-r from-blue-600 to-indigo-600 text-white'>
                                            <th className='py-3 px-4 text-left text-sm font-bold uppercase tracking-wider'>Cantidad</th>
                                            <th className='py-3 px-4 text-left text-sm font-bold uppercase tracking-wider'>Código</th>
                                            <th className='py-3 px-4 text-left text-sm font-bold uppercase tracking-wider'>Descripción</th>
                                            <th className='py-3 px-4 text-right text-sm font-bold uppercase tracking-wider'>Precio</th>
                                            <th className='py-3 px-4 text-right text-sm font-bold uppercase tracking-wider'>Subtotal</th>
                                            <th className='py-3 px-4 text-center text-sm font-bold uppercase tracking-wider'>Acciones</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {typeof venta !== 'undefined' && venta.map((item, index) => (
                                            <tr
                                                key={index}
                                                className='hover:bg-blue-50 transition-colors duration-150 border-b border-gray-100'
                                            >
                                                <td className='py-3 px-4 text-center font-semibold text-gray-800'>{item.cantidad}</td>
                                                <td className='py-3 px-4 text-center font-mono text-gray-600'>{item.codigo}</td>
                                                <td className='py-3 px-4 text-gray-800'>{item.descripcion}</td>
                                                <td className={`py-3 px-4 text-right font-semibold ${(item.tipopromo === '1' || item.tipopromo === '2') && 'bg-green-100 text-green-800'}`}>
                                                    ${tipoPrecio === 2 ? Math.round(item.preciopormayor) : tipoPrecio === 3 ? Math.round(item.preciopormayor2) : (item.tipopromo === '1' || item.tipopromo === '2') ? Math.round(item.preciopromocion) : Math.round(item.precio).toLocaleString("es-AR", { maximumFractionDigits: 2 })}
                                                </td>
                                                <td className={`py-3 px-4 text-right font-bold text-lg ${item.tipopromo === '3' && item.cantidad >= item.cantidadminima && 'bg-green-100 text-green-800'}`}>
                                                    ${tipoPrecio === 2 ? (parseFloat(item.preciopormayor) * parseFloat(item.cantidad)).toFixed(0) : tipoPrecio === 3 ? (parseFloat(item.preciopormayor2) * parseFloat(item.cantidad)).toFixed(0) : (item.tipopromo === '1' || item.tipopromo === '2') ? (parseFloat(item.preciopromocion) * parseFloat(item.cantidad)).toFixed(0) : item.tipopromo === '3' ? calcTotal(item) : (parseFloat(item.precio) * parseFloat(item.cantidad)).toLocaleString("es-AR", { maximumFractionDigits: 2 })}
                                                </td>
                                                <td className='py-3 px-4 text-center'>
                                                    <div className='flex items-center justify-center gap-2'>
                                                        <button
                                                            className='bg-gradient-to-r from-gray-500 to-gray-600 hover:from-gray-600 hover:to-gray-700 p-2.5 rounded-lg text-white shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200'
                                                            onClick={() => handleSet(item)}
                                                            title="Editar"
                                                        >
                                                            <FaPen />
                                                        </button>
                                                        <button
                                                            className='bg-gradient-to-r from-red-500 to-red-600 hover:from-red-600 hover:to-red-700 p-2.5 rounded-lg text-white shadow-md hover:shadow-lg transform hover:scale-105 transition-all duration-200'
                                                            onClick={() => handleDelete(item)}
                                                            title="Eliminar"
                                                        >
                                                            <FaTrash />
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    )}
                </div>
            </div>

            <FooterVenta />
        </div>
    )
}

export default FormVentas